const cloudName = document.querySelector(
  'meta[name="cloudinary-cloud-name"]',
)?.content;

const WIDTHS = [400, 768, 1024, 1440, 1700, 1920];
const BACKGROUND_SIZES = [
  400, 500, 600, 768, 800, 900, 1024, 1440, 1700, 1920, 2560,
];

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 10;
window.lazySizesConfig.init = false;
window.lazySizesConfig.rias = {
  widths: WIDTHS,
  widthmap: WIDTHS.reduce((acc, w) => {
    acc[w] = String(Math.floor(w));
    return acc;
  }, {}),
  prefix: `https://res.cloudinary.com/${cloudName}/image/upload/w_{width},dpr_auto,f_auto,q_auto:good/`,
};

function swapDeferSrc() {
  document.querySelectorAll(".lazyload").forEach((image) => {
    if (image.dataset.defersrc) {
      image.dataset.src = image.dataset.defersrc;
    }
  });
}

function initBackgroundImages() {
  const backgroundImages = document.querySelectorAll(".j-background-image");
  for (let i = 0; i < backgroundImages.length; i++) {
    const imagePath = backgroundImages[i].getAttribute("data-image-path");
    const width = parseInt(
      window.getComputedStyle(backgroundImages[i]).getPropertyValue("width"),
    );
    const height = parseInt(
      window.getComputedStyle(backgroundImages[i]).getPropertyValue("height"),
    );

    const closestWidth = BACKGROUND_SIZES.reduce((prev, curr) =>
      Math.abs(curr - width) < Math.abs(prev - width) ? curr : prev,
    );
    const closestHeight = BACKGROUND_SIZES.reduce((prev, curr) =>
      Math.abs(curr - height) < Math.abs(prev - height) ? curr : prev,
    );

    const multiple = 1.2;
    if (imagePath.length === 2) {
      // placeholder — skip
    } else if (closestHeight > closestWidth) {
      backgroundImages[i].style.backgroundImage = `url('https://res.cloudinary.com/${cloudName}/image/upload/h_${parseInt(multiple * closestHeight)},dpr_auto,f_auto,c_scale,q_auto:good/${imagePath}')`;
    } else {
      backgroundImages[i].style.backgroundImage = `url('https://res.cloudinary.com/${cloudName}/image/upload/w_${parseInt(multiple * closestWidth)},dpr_auto,f_auto,c_scale,q_auto:good/${imagePath}')`;
    }
  }
}

import("lazysizes/plugins/rias/ls.rias").then(() => {
  import("lazysizes").then((lazySizesModule) => {
    swapDeferSrc();
    initBackgroundImages();
    const lazySizes = lazySizesModule.default || lazySizesModule;
    lazySizes.init();
  });
});
